import * as React from "react";
const SvgFiRrMountainCity = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mountain-city_svg__a)">
      <path
        fill="#062147"
        d="M11.024 7.229a2.308 2.308 0 0 0-4.084.011L.31 20.138a2.61 2.61 0 0 0 .07 2.591A2.6 2.6 0 0 0 2.625 24h12.72c.926 0 1.766-.475 2.244-1.271a2.61 2.61 0 0 0 .073-2.585zm-2.312.936a.3.3 0 0 1 .272-.166c.068 0 .195.021.266.154l2.476 4.817-1.012 1.744-.88-1.422c-.187-.299-.533-.462-.867-.473a1 1 0 0 0-.85.501l-.804 1.397-1.086-1.72zm7.163 13.533a.61.61 0 0 1-.53.302H2.624a.61.61 0 0 1-.53-.302.63.63 0 0 1-.013-.635l3.085-6 .723 1.145c.313.498.875.814 1.44.792.588-.001 1.125-.3 1.456-.83l.23-.4.267.431c.312.499.85.797 1.437.799h.004c.586 0 1.123-.296 1.455-.824l.634-1.092 3.073 5.979.006.011a.63.63 0 0 1-.017.624M20 14a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1m-6-7a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2zm6-1a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1m0 4a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1m4-5v14.535c0 1.78-.958 3.439-2.5 4.331a.998.998 0 0 1-1.366-.366 1 1 0 0 1 .366-1.366 3.01 3.01 0 0 0 1.5-2.599V5c0-1.654-1.346-3-3-3h-5a3.01 3.01 0 0 0-2.599 1.5 1 1 0 1 1-1.73-1.001A5.02 5.02 0 0 1 14-.001h5c2.756 0 5 2.244 5 5.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mountain-city_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMountainCity;
